<template>
  <div
    class="label-lg fill-currentColor flex gap-2 items-center bg-primary-container border border-primary rounded-xl p-2"
  >
    <Icon v-if="icon" :name="icon" />
    <slot></slot>
  </div>
</template>

<script>
import Icon from '@/Components/Icon'

export default {
  name: 'Alert',
  components: { Icon },
  props: {
    icon: String,
  },
}
</script>

<style></style>
